import { useEffect, useRef } from 'react';
import useActions from "features/auth/useActions";

export default function useBootstrap() {
    const { getUser } = useActions();

    const apiHandlers = {
        getUser
    };

    const apiHandlersRef = useRef(apiHandlers);
    apiHandlersRef.current = apiHandlers;

    useEffect(() => {
        const { getUser } = apiHandlersRef.current;

        getUser();
    }, []);
};
